import { useEffect, useState } from 'react';
import GridSelectorInput from '../../../../components/controls/GridSelectorInput';
import { TextInput } from '../../../../components/controls/inputs';
import BaseDocumentCreator from '../../../../components/documents/baseDocumentCreator';
import { PluginWrapper } from '../../../../components/plugins';
import { IEntitySimpleDTO } from '../../../../libs/coreapi-dto/@types/common';
import { IAuthDataViewDTO } from '../../../../libs/coreapi-dto/service/authData';
import { IF3BusRegisterRequestDTO } from '../../../../libs/coreapi-dto/service/f3BusCore';
import { AuthDataDataProvider } from '../../../../Services/DataProviders/AuthDataDataProvider';
import { F3BusCoreDataProvider } from '../../../../Services/DataProviders/F3BusCoreDataProvider';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import F3BusCoreAgentsSelectorModal from '../components/F3BusCoreAgentsSelectorModal';
import GridWrapper from '../../../../components/controls/GridWrapper';

interface IConnectionSettingsF3busViewProps {
    plugin: IPluginSettings
}

export const ConnectionSettingsF3busView = (_props: IConnectionSettingsF3busViewProps) => {
    const appContext = useAppContext();
    const authDataDataProvider = new AuthDataDataProvider(appContext.coreApiService);
    const f3BusCoreDataProvider = new F3BusCoreDataProvider(appContext.coreApiService);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [supplier, setSupplier] = useState<IEntitySimpleDTO>();
    const [initialAuthData, setInitialAuthData] = useState<IAuthDataViewDTO>();
    const [isConnecting, setIsConnecting] = useState(false);

    useEffect(() => {
        authDataDataProvider.getClientName(
            'IF3BusCoreClient',
            (authDataResponse) => {
                if (authDataResponse.respType === 'isCompleted') {
                    const authData = authDataResponse.data;

                    setInitialAuthData(authData);
                    setLogin(authData.login ?? '');
                    setPassword(authData.password ?? '');
                    setSupplier(authData.clientId
                        ? {
                            idGlobal: authData.clientId,
                            displayName: authData.clientId,
                        }
                        : undefined,
                    );
                }
            },
        );
    }, []);

    const connect = () => {
        const clientId = supplier?.idGlobal ?? '';
        const selectedAgentId = Number(supplier?.idGlobal);
        const registerData: IF3BusRegisterRequestDTO = {
            sourceId: '',
            name,
            phone,
            email,
            address,
            isCentral: true,
            agentIds: Number.isFinite(selectedAgentId) ? [selectedAgentId] : [],
        };
        const isAuthDataChanged = initialAuthData !== undefined
            && (
                (initialAuthData.login ?? '') !== login
                || (initialAuthData.password ?? '') !== password
                || initialAuthData.clientId !== clientId
            );

        setIsConnecting(true);

        if (isAuthDataChanged && initialAuthData) {
            authDataDataProvider.createF3Bus({
                login,
                password,
                agentName: supplier?.displayName ?? '',
                agentId: clientId,
                isEnabled: initialAuthData.isEnabled,
            }, (ids) => {
                setInitialAuthData({
                    ...initialAuthData,
                    login,
                    password,
                    clientId,
                    idGlobal: ids[0] || initialAuthData.idGlobal,
                });
            });
        }

        f3BusCoreDataProvider.register(
            registerData,
            () => setIsConnecting(false),
            () => setIsConnecting(false),
        );
    };

    return (
        <BaseDocumentCreator
            valid
            ok={{
                title: 'Подключить',
                onClick: connect,
                disabled: isConnecting,
                sendRequestSpinner: isConnecting,
            }}
        >
            <PluginWrapper>
                <GridWrapper cols={2}>
                    <TextInput
                        inline
                        label="Логин"
                        value={login}
                        onChange={setLogin}
                    />
                    <TextInput
                        inline
                        // type="password"
                        autocomplete="new-password"
                        label="Пароль"
                        value={password}
                        onChange={setPassword}
                    />
                </GridWrapper>
                <GridWrapper cols={2}>
                    <TextInput
                        inline
                        label="Наименование"
                        value={name}
                        onChange={setName}
                    />
                    <TextInput
                        inline
                        label="Телефон"
                        value={phone}
                        onChange={setPhone}
                    />
                </GridWrapper>
                <GridWrapper cols={2}>
                    <TextInput
                        inline
                        label="Электронная почта"
                        value={email}
                        onChange={setEmail}
                    />
                    <TextInput
                        inline
                        label="Адрес"
                        value={address}
                        onChange={setAddress}
                    />
                </GridWrapper>
                <GridSelectorInput
                    inline
                    id="f3busSupplier"
                    label="Поставщик"
                    selectedEntity={supplier}
                    selectorModalJsx={F3BusCoreAgentsSelectorModal}
                    onSelect={setSupplier}
                    onClear={() => setSupplier(undefined)}
                />
            </PluginWrapper>
        </BaseDocumentCreator>
    )
}
